import React, { useEffect, useState } from 'react'
import SmartFilterSystem, { FilterItem } from '../Components/SmartFilterSystem'
import { SearchFilterResponse } from '../Types/SerachFileter';
import { getAllSearchFiltersBySubscriptionPlan } from '../Services/SearchFilterService';
import RecruiterHeaderComponent from '../../Recruiter/Components/RecruiterHeaderComponent';
import { storage } from '../../Shared/Utils/authStorage';

function SmartFilterSystemPage() {

  
   const [adminData, setAdminData] = useState<SearchFilterResponse []>([]);
        const [loading, setLoading] = useState<boolean>(true);
        const [error, setError] = useState<string>("");
        
        useEffect(() => {
          const fetchCandidate = async () => {
            try {
              setLoading(true); // Ensure loading is true when starting
              const response = await getAllSearchFiltersBySubscriptionPlan(storage.getUserId() ?? "");
    
              console.log("Search Filters based on Plan Response:", response);
        
              if (response.success) {
                setAdminData(response.data);
              } else {
                setError(response.message || "Could not retrieve recruiter profile.");
              }
            } catch (err) {
              setError("An unexpected error occurred while loading the profile.");
              console.error(err);
            } finally {
              setLoading(false);
            }
          };
        
          fetchCandidate();
        }, []); // Empty dependency array is fine if using localStorage




  return (
    <div>
      {/* <RecruiterHeaderComponent/> */}
      
      <SmartFilterSystem filters={adminData as FilterItem[]} />

</div>
  )
}

export default SmartFilterSystemPage